import { render, staticRenderFns } from "./orderMange.vue?vue&type=template&id=105f6254&scoped=true"
import script from "./orderMange.vue?vue&type=script&lang=js"
export * from "./orderMange.vue?vue&type=script&lang=js"
import style0 from "./orderMange.vue?vue&type=style&index=0&id=105f6254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f6254",
  null
  
)

export default component.exports